import { EventEmitter } from 'fbemitter';

const emitter = new EventEmitter();
// let userName = '';
let cartJSON = false;

const CartStore = {
  setCartJSON(json) {
    cartJSON = json;
    emitter.emit('cartAJAX');
  },

  getCartJSON() { return cartJSON },

  addListener(eventType: string, fn: Function) {
    return emitter.addListener(eventType, fn);
  },
};

export default CartStore;
